/* eslint-disable */
import { Component, Injector } from '@angular/core';
import { BaseRoute } from '../../../shared/components/base.route';

@Component({
  selector: 'ach-profile-failed',
  template: require('./ach-profile-failed.component.html')
})

export class AchProfileFailedComponent extends BaseRoute {
  constructor(injector: Injector) {
    super(injector);
  }

  ngOnInit() {
    this.fundInfo = this.appActions.getData('FundAccount');
  
    if (this.fundInfo) {
      const shortAccNum = this.fundInfo.accountNumber;
      const bankName = this.fundInfo.bankName;
      let hiddenAccountNumber = shortAccNum.substr(shortAccNum.length - 4);
      hiddenAccountNumber = `******${hiddenAccountNumber}`;
      this.form.inputs.accountNumber.noneditable = hiddenAccountNumber;
      this.form.inputs.bankName.noneditable = bankName;
    }
  }

  updateOptionValue(event) {
    let iPath = null;
    let value = event.value;

    // Data for agreemenets needs to be replaced with the date
    if (event.id && event.id.indexOf('Agreement') >= 0 && value === true) {
      const date = new Date();
      const dd = (date.getDate() < 10 ? '0' : '') + date.getDate();
      const mm = ((date.getMonth() + 1) < 10 ? '0' : '') + (date.getMonth() + 1);
      const yyyy = date.getFullYear();

      value = `${mm}/${dd}/${yyyy}`;
      iPath = `ApplicationInformation.${event.id}`
    }

    if (iPath !== undefined) {
      this.appActions.setData(iPath, value)
    }
  }

  btnClick(e) {
    if (e.action === 'next') {
      this._achProfileCreate();
    } else if (e.action === 'cancel-app') {
      if (this.flowManager.isAuthed) {
        this.flowManager.ssoToAlly();
      } else {
        this.router.navigate(['/credentials']);
      }
    }
  }

  _achProfileCreate() {
    this.modal.loadingModel();

    const fundAccountData = this.appActions.getData('FundAccount');
    let state = 0
    if(fundAccountData.nameFailout === true) {
      state = 1
    }

    const fundAccountInfo = {
      routingNumber: this.fundInfo.routingNumber,
      bankAccountNumber: this.fundInfo.accountNumber,
      bankAccountType: this.fundInfo.bankAccountType,
      bankAccountOwnershipType: this.fundInfo.bankAccountOwnershipType,
      bankName: this.fundInfo.bankName,
      state: state
    }

    this.appProxy.createACHProfile(fundAccountInfo, resp => {
      this.flowManager.hasManualACHProfile = true;
      this.modal.closeModal('manual');
    });
  }
}
